var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1057_34205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96847 7.75C4.92383 7.57697 4.83364 7.41905 4.70728 7.29269C4.58092 7.16633 4.42301 7.07614 4.24997 7.0315L1.18247 6.2405C1.13014 6.22565 1.08407 6.19413 1.05128 6.15072C1.01848 6.10732 1.00073 6.0544 1.00073 6C1.00073 5.9456 1.01848 5.89268 1.05128 5.84928C1.08407 5.80588 1.13014 5.77436 1.18247 5.7595L4.24997 4.968C4.42294 4.92341 4.58082 4.83329 4.70717 4.70702C4.83353 4.58075 4.92375 4.42295 4.96847 4.25L5.75947 1.1825C5.77417 1.12996 5.80566 1.08367 5.84913 1.0507C5.8926 1.01773 5.94566 0.999878 6.00022 0.999878C6.05478 0.999878 6.10784 1.01773 6.15131 1.0507C6.19478 1.08367 6.22627 1.12996 6.24097 1.1825L7.03147 4.25C7.07611 4.42304 7.1663 4.58095 7.29266 4.70731C7.41902 4.83367 7.57693 4.92386 7.74997 4.9685L10.8175 5.759C10.8702 5.77355 10.9167 5.80501 10.9499 5.84854C10.983 5.89207 11.001 5.94528 11.001 6C11.001 6.05472 10.983 6.10793 10.9499 6.15146C10.9167 6.195 10.8702 6.22645 10.8175 6.241L7.74997 7.0315C7.57693 7.07614 7.41902 7.16633 7.29266 7.29269C7.1663 7.41905 7.07611 7.57697 7.03147 7.75L6.24047 10.8175C6.22577 10.87 6.19428 10.9163 6.15081 10.9493C6.10734 10.9823 6.05428 11.0001 5.99972 11.0001C5.94516 11.0001 5.8921 10.9823 5.84863 10.9493C5.80516 10.9163 5.77367 10.87 5.75897 10.8175L4.96847 7.75Z",
    stroke: "#FC6A18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5V3.5",
    stroke: "#FC6A18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2.5H9",
    stroke: "#FC6A18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5V9.5",
    stroke: "#FC6A18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9H1.5",
    stroke: "#FC6A18",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1057_34205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.810db933.svg";
export { ForwardRef as ReactComponent };